

export function calculateSummerWinter() {
  const today = new Date();
  const first = new Date(today.getFullYear(), 0, 1);
  const dayOfYear = Math.round(((today - first) / 1000 / 60 / 60 / 24) + .5);
  return (dayOfYear < 60 || dayOfYear > 290)? 'winter': 'summer';
}
